// extracted by mini-css-extract-plugin
module.exports = {"link":"Navigation_link__4H5j9","activeLink":"Navigation_activeLink__11ETP"};